window.$      = window.jQuery = require('jquery');

/* --
/* Functions
/* -- */

//
// Smooth scrolling to anchor
function animToAnchor($target) {
  $('html, body').animate({
    scrollTop: $target.offset().top
  }, 250, function() {

    $target.focus();

    if($target.is(":focus")) {
      return false;
    } else {
      $target.attr('tabindex','-1');
      $target.focus();
    }
  });
}


/* --
  app
--*/

$(function() {
  // Hack to detect Safari browser
  // Usefull for input line height style fix
  if(navigator.userAgent.indexOf("Safari") > -1) { $('body').addClass('is-safari'); }

  //
  // Smooth scrolling
  $('a[href*="#"]').not('[href="#"]').not('[href="#0"]').on('click', function(event) {
    if(location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
      var $target = $(this.hash);
      $target = $target.length ? $target : $('[name=' + this.hash.slice(1) + ']');
      if($target.length) {
        event.preventDefault();

        animToAnchor($target);
      }
    }
  });

  $('.js-toggle-share').on('click', function() {
    $(this).find('.c-share__pannel').toggleClass('c-share__pannel--open')
  });

  $('#back-to-top').on('click', function() {
    animToAnchor($('[name="site-top"]'));
  });

  //
  // Back to top button
  (function() {
    var lastScroll = 0;
    var $backToTopButton = $('#back-to-top');

    $(window).scroll(function(){
      var st = $(this).scrollTop();

      if (st > lastScroll){
        $backToTopButton.removeClass('o-back-to-top--show');
      }
      else {
        $backToTopButton.addClass('o-back-to-top--show');
      }
      lastScroll = st;
    });
  })();

  //
  // Scrollable table
  $('.scrollable-table').each(function() {
    var $el = $(this),
        $elInner = $el.children(),
        $elTable = $el.find('table'),
        scrollableClass = 'scrollable-table--scrollable';

    // Check if the $el is wider than its parent and thus needs to be scrollable
    if($elTable.outerWidth() > $elInner.outerWidth()) {
      $el.addClass(scrollableClass);
    }
    // When the viewport size is changed, check again if the $el needs to be scrollable
    $(window).on('resize orientationchange', function() {
      if($elTable.outerWidth() > $elInner.outerWidth()) {
        $el.addClass(scrollableClass);
      } else {
        $el.removeClass(scrollableClass);
      }
    }).resize();
  });

  //
  // Forms validation
  $('form').on('submit', function(event) {
    var $form = $(this)

    $form.find('input, select').each(function() {
      var $el = $(this),
        $group = $el.closest('.l-form-group'),
        $field = $el.closest('.l-form-group__field'),
        errorMessage = $field.data('error-message')

      if (!$el[0].validity.valid) {
        $group.addClass('l-form-group--invalid')

        if (errorMessage) {
          if ($field.siblings('.o-form-message')) {
            $field.siblings('.o-form-message').text(errorMessage)
          }
          if ($group.siblings('.o-form-message')) {
            $group.siblings('.o-form-message').text(errorMessage)
          }
        }

        event.preventDefault()
      }

      $field.find('.o-form-control').on('click', function() {
        $group.removeClass('l-form-group--invalid')
      })
    })
  })

  $('[data-columns]').each(function() {
    var $el = $(this)
        nbCol = $el.data('columns')

    $el.attr('style', 'columns:' + nbCol + ';')
  })
});
